// Centralized PDF.js worker configuration for capture-ui
// This ensures consistent worker setup across all PDF components

import { pdfjs } from 'react-pdf';
import * as pdfjsLib from 'pdfjs-dist';

// Configure worker for both react-pdf and pdfjs-dist
const configureWorker = () => {
  const workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;
  
  // Configure react-pdf worker
  if (!pdfjs.GlobalWorkerOptions.workerSrc) {
    pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
    console.log('[PDF Worker] react-pdf worker configured:', workerSrc);
  }
  
  // Configure pdfjs-dist worker
  if (!pdfjsLib.GlobalWorkerOptions.workerSrc) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
    console.log('[PDF Worker] pdfjs-dist worker configured:', workerSrc);
  }
};

// Initialize worker configuration immediately
configureWorker();

export { configureWorker };
